/* @flow weak */
import Input from 'components/Input.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import ReactDOM from 'react-dom';

/**
 * ## Number-only [Input](/internal/components/Input).
 *
 *
 * ```example
 * <NumberInput />
 * ```
 */

class NumberInput extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  state = {
    value: this.props.value || '',
  };
  getInputNode() {
    return ReactDOM.findDOMNode(this.refs.input);
  }

  handleChange(event) {
    let value = event.target.value.replace(/^(?!\d+\.?\d)$/, '');
    const values = value.split('.');

    if (values[1] && values[1].length > 2) {
      value = values[0] + '.' + values[1].substr(0, 2);
    }

    if (!isNaN(value)) {
      this.setState({ value });
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }

  render() {
    return (
      <Input
        {...this.props}
        ref="input"
        type="text"
        value={this.state.value}
        onChange={this.handleChange.bind(this)}
      />
    );
  }
}

export default NumberInput;
